import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import dateStartNamesForTypes from '../constants/dateStartNamesForTypes';
import templatesNamesForTypes from '../constants/templatesNamesForTypes';

const useCreateNoticeValidator = () => {
  const [disabled, setDisabled] = useState();
  const [errors, setErrors] = useState();

  const createNotice = useSelector((store) => store.debtsStore.createNotice);
  const { page, lastPage, pageName, title, start } = createNotice;
  useEffect(() => {
    const errorsText = [];
    if (!pageName) {
      if (lastPage === 0) {
        errorsText.push('типы оповещения не выбраны');
      }
      if (!title) {
        errorsText.push('заголовок не указан');
      }
      if (!start) {
        errorsText.push('время старта не указано');
      }
    }
    if (pageName) {
      if (
        !createNotice[dateStartNamesForTypes[pageName]] &&
        !createNotice?.start
      ) {
        errorsText.push('дата начала оповещения не указана');
      }

      if (!createNotice[templatesNamesForTypes[pageName]]) {
        errorsText.push('шаблон не выбран');
      }
    }

    if (pageName === 'EMAIL') {
      if (!createNotice.EmailId) {
        errorsText.push('почта не указана');
      }
    }
    setDisabled(!!errorsText.length);
    if (errorsText.length) {
      setErrors('Нельзя перейти к следующему этапу: ' + errorsText.join(', '));
    }
  }, [pageName, lastPage, createNotice, page]);

  return [disabled, errors];
};
export default useCreateNoticeValidator;
